import { useTranslationContext } from "../Hooks/useTranslationContext";

const FlagSwe = () => {
  const { setLanguage } = useTranslationContext();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      onClick={() => setLanguage("swe")}
      cursor="pointer"
    >
      <path fill="#1976D2" d="M2 9H46V39H2z"></path>
      <path fill="#FFC107" d="M2 21H46V27H2z"></path>
      <path fill="#FFC107" d="M16 9H22V39H16z"></path>
    </svg>
  );
};

export default FlagSwe;
